import { useLang } from "@/i18n/LanguageContext";
import { Button } from "@/components/ui/button";

export const LanguageSwitcher = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="inline-flex items-center rounded-md border border-border overflow-hidden text-xs font-semibold">
      <button
        onClick={() => setLang("de")}
        className={`px-2.5 py-1 transition-colors ${lang === "de" ? "bg-accent text-accent-foreground" : "bg-transparent text-foreground/70 hover:bg-muted"}`}
        aria-label="Deutsch"
      >DE</button>
      <button
        onClick={() => setLang("en")}
        className={`px-2.5 py-1 transition-colors ${lang === "en" ? "bg-accent text-accent-foreground" : "bg-transparent text-foreground/70 hover:bg-muted"}`}
        aria-label="English"
      >EN</button>
    </div>
  );
};

// keep Button import to silence unused warnings if needed
export const _b = Button;